import React from "react";
import { connect } from "react-redux";

function LinearProgress(props) {
  return (
    <>
      {props.loading ? (
        <div className="wr-linearProgress">
          <div className="content-linearProgress"></div>
        </div>
      ) : null}
    </>
  );
}
export default connect(({ admins }) => ({
  loading: admins.loading,
}))(LinearProgress);
